import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, User, ShieldCheck, HelpCircle, LogOut, Palette } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { ThemePicker } from "@/components/ThemePicker";
import { startTour } from "@/components/GuidedTour";

const itemCls = "flex items-center gap-3 px-3 py-3 border-b border-bt-border-subtle text-sm font-body text-bt-text-primary hover:bg-bt-surface-2 transition-colors w-full text-left";

export default function MobileMenu({ user, logout }) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button className="md:hidden shrink-0 p-1.5 border border-bt-border-subtle bg-bt-surface text-bt-text-secondary hover:text-bt-gold transition-colors" aria-label="Menu" data-testid="mobile-menu-btn">
          <Menu className="w-4 h-4" strokeWidth={1.5} />
        </button>
      </SheetTrigger>
      <SheetContent side="right" className="w-72 bg-bt-bg border-bt-border-subtle p-0" data-testid="mobile-menu">
        <SheetHeader className="px-4 py-4 border-b border-bt-border-subtle text-left">
          <SheetTitle className="font-heading text-bt-text-primary truncate">{user.name || user.email}</SheetTitle>
          {user.role === "superadmin" && <span className="w-fit text-[9px] font-mono px-1 py-0.5 bg-bt-gold/20 text-bt-gold border border-bt-gold/30">ADMIN</span>}
        </SheetHeader>
        <Link to="/profile" onClick={close} className={itemCls} data-testid="mobile-menu-profile"><User className="w-4 h-4 text-bt-text-tertiary" />Profile</Link>
        {user.role === "superadmin" && (
          <Link to="/admin" onClick={close} className={itemCls} data-testid="mobile-menu-admin"><ShieldCheck className="w-4 h-4 text-bt-text-tertiary" />Admin</Link>
        )}
        <div className={`${itemCls} justify-between`} data-testid="mobile-menu-theme">
          <span className="flex items-center gap-3"><Palette className="w-4 h-4 text-bt-text-tertiary" />Theme &amp; background</span>
          <ThemePicker />
        </div>
        <button onClick={() => { close(); setTimeout(startTour, 300); }} className={itemCls} data-testid="mobile-menu-tour"><HelpCircle className="w-4 h-4 text-bt-text-tertiary" />Take the tour</button>
        <button onClick={() => { close(); logout(); }} className={`${itemCls} text-bt-negative`} data-testid="mobile-menu-logout"><LogOut className="w-4 h-4" />Log out</button>
      </SheetContent>
    </Sheet>
  );
}
